<template>
  <div>
    <inline-form :company="company" :editable="editable">

      <template slot="fields">
        <label for="v-company-name" class="cm-label">{{ I18n.t('name') }}</label>
        <input id="v-company-name" type="text" class="cm-field" v-model="company.name" />
      </template>

      <h1 class="name">
        <a :href="`/companies/${company.id}`">{{ company.name }}</a>
      </h1>
    </inline-form>
  </div>
</template>

<script>
  import InlineForm from './inline-form'

  export default {
    props: ['id', 'value', 'editable'],
    data: function () {
      return {
        company: {
          id: this.id,
          name: this.value
        }
      }
    },
    components: {
      InlineForm
    }
  }
</script>

<style scoped lang="scss">
  .name {
    @extend %h3;
  }

  a {
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// app/javascript/company/name.vue?16cec12f